<template>
  <div class="error-page">
    <div class="error-page__glow error-page__glow--1" />
    <div class="error-page__glow error-page__glow--2" />

    <span class="error-page__watermark">404</span>

    <router-link to="/" class="error-page__logo-wrap">
      <img src="./../assets/Intelligential-logo-texto-blanco.png" class="error-page__logo" />
    </router-link>

    <div class="error-page__body">
      <p class="error-page__eyebrow">Error 404</p>
      <h1 class="error-page__title">Página no encontrada</h1>
      <p class="error-page__desc">La ruta que estás buscando no existe o fue movida.<br>Verifica la URL o regresa al inicio.</p>
      <div class="error-page__actions">
        <button class="error-page__btn-primary" @click="returnPrevView">
          <i class="fas fa-arrow-left" /> Regresar
        </button>
        <router-link class="error-page__btn-ghost" to="/">
          Ir al inicio
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['returnPrevView'])
  }
}
</script>
